import { MelcoModelsPermissionsListItem } from "melco-shared-logic";

interface rolesData {
  [key: string]: boolean | string;
}

export const useAppRoles = (
  permissions_list: MelcoModelsPermissionsListItem[]
) => {
  console.log(permissions_list);
  try {
    let r: rolesData = {};
    permissions_list.map((p: any) => {
      let code = p?.code;
      let filterList = p?.filter_list;

      if (code && code !== "") {
        r[code] = true;
      }
      if (code && filterList && filterList !== "") {
        let elementName = code + "_FILTER_LIST";
        r[elementName] = filterList;
      }
      // return value added only to satisfy Array.prototype.map()
      return null;
    });

    return {
      roles: r,
      success: true,
    };
  } catch (error) {
    // just to be safe: in case there is any error, we don't want the user to being able to use the app. hence we rather redirect him back to the account app for now.

    return {
      roles: {},
      success: false,
    };
  }
};
